import { FormattedValue } from "@utils/formatters";
import clsx from "clsx";

export const COLOR_MAP = {
  default: "text-white",
  red: "text-red",
  green: "text-green",
  blue: "text-blue",
  aqua: "text-aqua",
  grey: "text-white text-opacity-50",
  green2: "text-green2",
  red2: "text-red2",
};

export const Formatted = ({
  value,
  className,
  withSign = false,
  withTrendArrow = false,
  smallSpace = false,
}: {
  value: FormattedValue;
  className?: string;
  withSign?: boolean;
  withTrendArrow?: boolean;
  smallSpace?: boolean;
}) => {
  const sign = withSign ? value.getSign() : "";

  const resolveValue = () => {
    const str = value.toString();
    const match = str.match(/^(.*?)<sub>(.*?)<\/sub>(.*)$/);

    if (!match) return str;

    const [, before, subValue, after] = match;
    return (
      <>
        {before}
        <span className="text-[0.5rem]">{subValue}</span>
        {after}
      </>
    );
  };

  return (
    <div
      className={clsx(
        className,
        COLOR_MAP[value.getColor()],
        "text-xs flex items-center"
      )}
    >
      {sign}
      {withTrendArrow && value.getTrendArrow() !== "" && (
        <span
          className={clsx(
            "text-[0.313rem]",
            smallSpace ? "pr-[0.188rem]" : "pr-[0.3125rem]"
          )}
        >
          {value.getTrendArrow()}
        </span>
      )}
      {resolveValue()}
    </div>
  );
};
